/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateUserRoleRelationDto
 */
export interface UpdateUserRoleRelationDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRoleRelationDto
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRoleRelationDto
     */
    roleId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserRoleRelationDto
     */
    relation?: boolean;
}

export function UpdateUserRoleRelationDtoFromJSON(json: any): UpdateUserRoleRelationDto {
    return UpdateUserRoleRelationDtoFromJSONTyped(json, false);
}

export function UpdateUserRoleRelationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserRoleRelationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'roleId': !exists(json, 'roleId') ? undefined : json['roleId'],
        'relation': !exists(json, 'relation') ? undefined : json['relation'],
    };
}

export function UpdateUserRoleRelationDtoToJSON(value?: UpdateUserRoleRelationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'roleId': value.roleId,
        'relation': value.relation,
    };
}


